import r from "./highrise1604.mjs";
import i from "./highrise1676.mjs";
function f(t, a) {
  var e = i(t, a);
  return r(e) ? e : void 0;
}
export {
  f as default
};
